var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "room-setting-display-component" }, [
    _vm.isRoomMode("group") || _vm.isRoomMode("exam")
      ? _c("div", { staticClass: "room-setting-display-disable-wrapper" }, [
          _c("p", { staticClass: "room-setting-display-disable--text" }, [
            _vm._v(_vm._s(_vm.setDisableText())),
          ]),
        ])
      : _c("div", { staticClass: "room-setting-display-wrapper" }, [
          _c("div", { staticClass: "select-display-setting" }, [
            _c("div", { staticClass: "room-setting-content-box" }, [
              _c("h6", { staticClass: "room-setting-content-title" }, [
                _vm._v(_vm._s(_vm.$t("setting.layout.type.title"))),
              ]),
              _c("div", { staticClass: "room-setting-content-text-box" }, [
                _c("div", { staticClass: "room-setting-content-text" }, [
                  _vm._v(_vm._s(_vm.$t("setting.layout.type.message"))),
                ]),
              ]),
              _c("div", { staticClass: "room-setting-input-box" }, [
                _c("div", { staticClass: "room-set-block-btn-box" }, [
                  _c(
                    "ul",
                    _vm._l(_vm.displayModeList, function (displayMode) {
                      return _c(
                        "li",
                        {
                          key: displayMode.type,
                          class: [
                            {
                              selected:
                                _vm.selected.displayMode === displayMode.type,
                            },
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.onClickDisplayMode(displayMode)
                            },
                          },
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "room-set-block-btn",
                              attrs: { tabindex: "1" },
                            },
                            [_vm._v(_vm._s(displayMode.name))]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "room-setting-content-box" }, [
              _c("h6", { staticClass: "room-setting-content-title" }, [
                _vm._v(_vm._s(_vm.$t("setting.layout.set.title"))),
              ]),
              _c("div", { staticClass: "room-setting-content-text-box" }, [
                _c("p", { staticClass: "room-setting-content-text" }, [
                  _vm._v(_vm._s(_vm.$t("setting.layout.set.message"))),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "room-setting-input-box" }, [
              _c("div", { staticClass: "room-set-block-btn-box" }, [
                _c(
                  "ul",
                  _vm._l(
                    _vm.layoutTypeList[_vm.selectedDisplayMode],
                    function (layoutArr, type) {
                      return _c(
                        "li",
                        {
                          key: type,
                          class: {
                            selected:
                              (_vm.selected.videoLayoutType || "grid") === type,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onClickLayoutType(type)
                            },
                            touchend: function ($event) {
                              return _vm.onClickLayoutType(type)
                            },
                          },
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "room-set-block-btn",
                              attrs: { tabindex: "1" },
                            },
                            [_vm._v(_vm._s(_vm.layoutTypeName(type)))]
                          ),
                        ]
                      )
                    }
                  ),
                  0
                ),
              ]),
            ]),
            _vm.selectedLayoutList?.length
              ? _c(
                  "div",
                  {
                    staticClass:
                      "room-setting-input-box screen-layout-type-select",
                    class: {
                      "opacity-50 pointer-events-none":
                        _vm.useWallModeTargetScreen &&
                        _vm.selectedWallModeTargetScreenType === "speaker",
                    },
                  },
                  [
                    _c(
                      "ul",
                      { staticClass: "screen-layout-type" },
                      _vm._l(_vm.selectedLayoutList, function (videoLayout) {
                        return _c(
                          "li",
                          {
                            key: videoLayout,
                            staticClass: "screen-layout-item",
                            on: {
                              mouseover: function ($event) {
                                _vm.layoutExample = videoLayout
                              },
                            },
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "video-layout-type-btn",
                                class: {
                                  selected:
                                    _vm.selectedVideoLayout === videoLayout,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.onClickLayout(
                                      videoLayout,
                                      $event
                                    )
                                  },
                                  touchend: function ($event) {
                                    return _vm.onClickLayout(
                                      videoLayout,
                                      $event
                                    )
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.setLayoutNumber(videoLayout)))]
                            ),
                            _vm.layoutExample !== ""
                              ? _c(
                                  "div",
                                  { staticClass: "video-layout-preview-item" },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require(`@/assets/images/layout/${
                                          _vm.isLiveModeSelected
                                            ? "ml_01_00"
                                            : _vm.layoutExample
                                        }.jpg`),
                                        width: _vm.isWallModeSelected
                                          ? "100%"
                                          : "55%",
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                )
              : _vm._e(),
          ]),
          _vm.useWallModeTargetScreen && _vm.selected.videoLayoutType === "wall"
            ? _c("div", { staticClass: "room-setting-content-box mt-6" }, [
                _c("div", { staticClass: "select-wall-mode-target-screen" }, [
                  _c("h6", { staticClass: "room-setting-content-title" }, [
                    _vm._v(_vm._s(_vm.$t("setting.wall.layout.title"))),
                  ]),
                  _c("div", { staticClass: "room-setting-content-text-box" }, [
                    _c("p", {
                      staticClass: "room-setting-content-text",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("setting.wall.layout.description")
                        ),
                      },
                    }),
                  ]),
                  _c("div", { staticClass: "room-setting-input-box" }, [
                    _c("div", { staticClass: "room-set-block-btn-box" }, [
                      _c(
                        "ul",
                        _vm._l(
                          _vm.wallModeTargetScreenList,
                          function (targetScreen) {
                            return _c(
                              "li",
                              {
                                key: targetScreen.type,
                                class: [
                                  {
                                    selected:
                                      _vm.selectedWallModeTargetScreenType ===
                                      targetScreen.type,
                                  },
                                ],
                                on: {
                                  click: function ($event) {
                                    return _vm.onChangeWallModeTargetScreen(
                                      targetScreen.type
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "room-set-block-btn",
                                    attrs: { tabindex: "1" },
                                  },
                                  [_vm._v(_vm._s(targetScreen.name))]
                                ),
                              ]
                            )
                          }
                        ),
                        0
                      ),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm.selectedDisplayMode === _vm.displayModeList[1].type
            ? _c("div", { staticClass: "room-setting-content-box mt-6" }, [
                _c("div", { staticClass: "select-qna-mode" }, [
                  _c("h6", { staticClass: "room-setting-content-title" }, [
                    _vm._v(_vm._s(_vm.$t("qna.list.btn"))),
                  ]),
                  _c("div", { staticClass: "room-setting-content-text-box" }, [
                    _c("p", { staticClass: "room-setting-content-text" }, [
                      _vm._v(_vm._s(_vm.$t("setting.layout.qna.text"))),
                    ]),
                  ]),
                  _c("div", { staticClass: "room-setting-input-box" }, [
                    _c("label", { staticClass: "room-setting-label" }, [
                      _c("input", {
                        attrs: { name: "setQnaMode", type: "checkbox" },
                        domProps: { checked: _vm.useQnA },
                        on: {
                          input: function ($event) {
                            return _vm.CHANGE_SETTING_DATA({
                              type: "useQnA",
                              value: $event.target.checked,
                            })
                          },
                        },
                      }),
                      _c("span", [_vm._v(_vm._s(_vm.$t("common.use")))]),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "select-qna-share-mode mt-8" }, [
                  _c("h6", { staticClass: "room-setting-content-title" }, [
                    _vm._v(_vm._s(_vm.$t("setting.layout.qna.share.title"))),
                  ]),
                  _c("div", { staticClass: "room-setting-content-text-box" }, [
                    _c("p", { staticClass: "room-setting-content-text" }, [
                      _vm._v(_vm._s(_vm.$t("setting.layout.qna.share.text"))),
                    ]),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "room-setting-input-box",
                      class: { disable: !_vm.useQnA },
                    },
                    [
                      _c("label", { staticClass: "room-setting-label" }, [
                        _c("input", {
                          attrs: { name: "setQnaShareMode", type: "checkbox" },
                          domProps: { checked: _vm.useQnAShare },
                          on: {
                            input: function ($event) {
                              return _vm.CHANGE_SETTING_DATA({
                                type: "useQnAShare",
                                value: $event.target.checked,
                              })
                            },
                          },
                        }),
                        _c("span", [_vm._v(_vm._s(_vm.$t("common.share")))]),
                      ]),
                    ]
                  ),
                ]),
              ])
            : _vm._e(),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }